function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import merge from 'deepmerge';
import wrapInSvgString from './utils/wrap-in-svg-string';
import defaultConfig from './sprite.config';

var Sprite = /*#__PURE__*/function () {
  /**
   * @param {Object} [config]
   */
  function Sprite(config) {
    _classCallCheck(this, Sprite);

    this.config = merge(defaultConfig, config || {});
    this.symbols = [];
  }
  /**
   * Add new symbol. If symbol with the same id exists it will be replaced.
   * @param {SpriteSymbol} symbol
   * @return {boolean} `true` - symbol was added, `false` - replaced
   */


  _createClass(Sprite, [{
    key: "add",
    value: function add(symbol) {
      var symbols = this.symbols;
      var existing = this.find(symbol.id);

      if (existing) {
        symbols[symbols.indexOf(existing)] = symbol;
        return false;
      }

      symbols.push(symbol);
      return true;
    }
    /**
     * Remove symbol & destroy it
     * @param {string} id
     * @return {boolean} `true` - symbol was found & successfully destroyed, `false` - otherwise
     */

  }, {
    key: "remove",
    value: function remove(id) {
      var symbols = this.symbols;
      var symbol = this.find(id);

      if (symbol) {
        symbols.splice(symbols.indexOf(symbol), 1);
        symbol.destroy();
        return true;
      }

      return false;
    }
    /**
     * @param {string} id
     * @return {SpriteSymbol|null}
     */

  }, {
    key: "find",
    value: function find(id) {
      return this.symbols.filter(function (s) {
        return s.id === id;
      })[0] || null;
    }
    /**
     * @param {string} id
     * @return {boolean}
     */

  }, {
    key: "has",
    value: function has(id) {
      return this.find(id) !== null;
    }
    /**
     * @return {string}
     */

  }, {
    key: "stringify",
    value: function stringify() {
      var attrs = this.config.attrs;
      var stringifiedSymbols = this.symbols.map(function (s) {
        return s.stringify();
      }).join('');
      return wrapInSvgString(stringifiedSymbols, attrs);
    }
    /**
     * @return {string}
     */

  }, {
    key: "toString",
    value: function toString() {
      return this.stringify();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.symbols.forEach(function (s) {
        return s.destroy();
      });
    }
  }]);

  return Sprite;
}();

export { Sprite as default };